import scrollDirective from './scroll';
import formatDirective from './format';

scrollDirective.install({});
formatDirective.install({});
